import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { projects } from "@/data/projects";
import PortfolioGrid from "@/components/PortfolioGrid";
import { PORTFOLIO } from "@/constants/testIds";

const FEATURED_COUNT = 7;

export default function Portfolio() {
  const featured = projects.slice(0, FEATURED_COUNT);
  const remaining = projects.length - FEATURED_COUNT;

  return (
    <section
      id="portfolio"
      data-testid={PORTFOLIO.section}
      className="relative py-24 md:py-32 border-t border-cyan-900/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="overline">/ 02 portfolio.archive</div>
            <h2 className="mt-4 font-mono-display text-3xl sm:text-4xl md:text-5xl font-extrabold uppercase tracking-tighter text-slate-100">
              Missions <span className="text-neon-fuchsia">completed</span>
            </h2>
          </div>
          <p className="max-w-md text-slate-400 font-body">
            Selected work across government, tourism, enterprise, and consumer verticals. Tap any tile for details.
          </p>
        </div>

        <PortfolioGrid projects={featured} />

        {remaining > 0 && (
          <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
            <span className="font-hud text-slate-500">
              +{remaining} more missions in the full archive
            </span>
            <Link
              to="/portfolio"
              data-testid="portfolio-show-more"
              className="btn-neon"
            >
              Access_full_archive <ArrowRight size={13} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
